import type { Subcategory } from '../model'

export function getSubcategory({
  category,
  subcategories,
}: {
  category: string | null | undefined
  subcategories: Subcategory[]
}) {
  return subcategories.find(({ label }) => label === category) ?? null
}
